import React from 'react'
import { withFirebase } from '../Fb'

// The Tiedustelut menu badge: inquiries still in status 'new', live, since partners send them
// at any time.
function InquiriesBadge({ firebase }) {
  const [count, setCount] = React.useState(0)
  React.useEffect(() => firebase.listenNewInquiryCount(setCount), [firebase])
  if (!count) return null
  return (
    <span className='sidebar-count' aria-label={count + ' uutta'}>
      {count}
    </span>
  )
}

export default withFirebase(InquiriesBadge)
